const { REACT_APP_AIRTABLE_API_KEY, REACT_APP_AIRTABLE_API_URL } = process.env;

export const makeRequest = (id, date, duration) => {
	return fetch(REACT_APP_AIRTABLE_API_URL + '/PTO_Requests', {
		method: 'POST',
		headers: {
			'Authorization': 'Bearer ' + REACT_APP_AIRTABLE_API_KEY,
			'Content-Type': 'application/json'
		},
		body: JSON.stringify({
			fields: {
				dateRequested: date,
				employee: [id],
				duration: duration * 3600
			}
		})
	})
		.then(resp => resp.json())
		.then(json => json);
}


// WEBPACK FOOTER //
// ./src/utils/makeRequests.js